module.exports = __webpack_public_path__ + "static/img/irole.09d8f65.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/sy/irole.png
// module id = gpZr
// module chunks = 7